import options from './thing-labels.component';

export default {
    selector: 'dtAsThingLabels',
    options
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/search/advanced/thing-labels/index.js